import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import styled from 'styled-components';
import {observer} from 'mobx-react';

import {history} from '../history';
import { ButtonMover } from './Buttons';
import { ProgressBar } from './ProgressBar';
import { TopBarLevelUp } from './TopBarLevelUp';
import { TopBarAchReward } from './TopBarAchReward';
import { TopBarAdModal } from './TopBarAdModal';
import { motion, AnimatePresence } from 'framer-motion';

import {times, max} from 'lodash';
import { TopBarPurchaseComplete } from './TopBarPurchaseComplete';

const Body = styled.div`
	transform: translate3d(0,0,0);
	display: flex;
	flex-basis: 15vw;
	width: 100%;
	flex-shrink: 0;
	flex-grow: 0;
	background-size: 100% 100%;
	flex-direction: row;
	align-items: center;
	& > div {
		margin-left: 4vw;
		&:last-child {
			margin-right: 4vw;
		}
	}
	font-size: 3vw;
	overflow: visible;
	z-index: 2000;
`
const LvlBar = styled.div`
	width: 64%;
	height: 54%;
	margin-bottom: 7%;
	box-sizing: border-box;
	overflow: hidden;
`

const HeartBar = styled.div`
	width: 69%;
	height: 54%;
	margin-bottom: 7%;
	box-sizing: border-box;
	overflow: hidden;
`

const IconBar = styled.div`
	height: 100%;
	position: relative;
	& > img {
		position: absolute;
		top: 0;
		left: 0;
	}
	display: flex;
	align-items: center;
	justify-content: flex-end;
`

const HeartNumber = styled.div`
	color: white;
	font-size: 5vw;
	line-height: 8vw;
	text-align: right;
	margin-right: -3vw;
`


const Modal = styled(motion.div)`
	position: absolute;
	top: 15vw;
	margin: 0 !important;
	padding: 0;
	height: 100vh;
	background-color: rgba(0,0,0,0.5);
	z-index: 1500;
	width: 100vw;
	opacity: 1;
`

const Heart = styled(motion.img)`
	width: 10vw;
	position: absolute;
	z-index: 2500;
`

const Level = styled.div`
	color: #6a2c00;
	z-index: 10;
	width: 13vw;
	position: absolute;
	top: 3.75vw;
	height: 5.75vw;
	line-height: 5.75vw;
	left: 0;
	text-align: center;
	text-shadow: 0.1em 0.1em 0.1em rgba(255,228,116,1);
`

@observer
export class TopBar extends Component {

	openProfile = () => {
		window.manager.playAudio("poopPop");
		store.showProfile = !store.showProfile;
	}

	backTo = () => {
		window.manager.playAudio("poopPop");
		history.push(store.topBar.to);
	}

	back = () => {
		window.manager.playAudio("poopPop");
		history.goBack();
	}

	openStore = () => {
		if(!store.showProductStore && store.activeMatch === null){
			window.manager.playAudio("poopPop");
			console.log(`shakeproduct TopBar Store Button`);
			window.manager.showProductStore();
		}
	}

	timer = Date.now();

	lvlInProgress = false;

	firstStarAnimated = (andLast) => {
		if(store.user.xpData.nextStep() === 'increment-lvl'){
			this.levelUp();
		}
		if(andLast){
			this.lastStarAnimated();
		}
	}

	lastStarAnimated = () => {
		setTimeout(() => {
			if(store.showAchRewardBanner.length){
				store.showAchRewardBanner = [];
			}
			if(store.user.xpData.nextStep() === 'increment-lvl'){
				this.levelUp();
			}
		},1000)
	}

	heartsComplete = () => {
		store.user.heartAnimComplete();
		setTimeout(() => {
			store.showLevelUpReward = [];
		},500);
	}

	timedHeartsComplete = () => {
		store.showTimedHeartAward = 0;
	}

	adHeartsComplete = () => {
		// store.showCountdownModal = false;
	}

	barAnimationComplete = () => {
		if(store.user.xpData.nextStep() === 'increment-lvl'){
			this.levelUp();
		}
	}

	levelUp(){
		var level = store.user.xpData.currentLevel
		// var isOdd = !!(level % 2)
		// var hearts = level > 23 || !isOdd ? 4 : 2;
		var time = Date.now();
		store.user.updateHearts()
		.then(() => {
			setTimeout(() => {
				store.showLevelUpReward = [level, store.user.heartsGained];
			}, 500 - (Date.now() - time));
		});
	}

	prevent(e){
		// console.log('prevent',store.showProductStore, store.purchaseComplete);
		if(store.showProductStore || store.purchaseComplete){
			e.stopPropagation();
		}
		// e.preventDefault();
	}

	render(){
		const inRewardMode = store.showAchRewardBanner.length > 0;
		const inLevelUpMode = store.showLevelUpReward.length > 0 && !inRewardMode;
		const inTimedHeartMode = store.showTimedHeartAward > 0;
		const showCountdownModal = store.showCountdownModal && !inLevelUpMode && !inRewardMode;
		const inPurchaseComplete = store.purchaseComplete;

		const showModalBg = inRewardMode || inLevelUpMode || showCountdownModal || inPurchaseComplete;
		var delayBeforeFirstStar = 1;

		var style = {
			backgroundImage: `url('/assets/hud/hud_theme_vegas_gold.png')`
		};
		if(this.props.overlay){
			style.top = 0;
			style.left = 0;
			style.position = 'absolute';
		}
		if(this.props.blue){
			style.backgroundImage = `url('/assets/hud/hud_theme_vegas_blue.png')`;
		}
		if(store.topBar.hide){
			style.backgroundImage = "none";
			// style.pointerEvents = "none";
		}
		var delayIncrement = 0;

		// console.log('delay',{rewardMode: inRewardMode, xp: xpShownAmt,
		// 	showBanner: store.showAchRewardBanner[1],
		// 	delay: delayBeforeFirstStar, end: delayIncrement, elapsed: (Date.now() - this.timer) / 1000});
		this.timer = Date.now();
		return (
			<Body
				onClick={this.prevent}
				onMouseDown={this.prevent}
				onMouseUp={this.prevent}
				onTouchStart={this.prevent}
				onPointerUp={this.prevent}
				onPointerDown={this.prevent}
				style={style}
			>
				<AnimatePresence>
					{showModalBg && <Modal key="modalBg"
						initial={{opacity: 0}} exit={{opacity: 0}} animate={{opacity: 1}}
						transition={{duration: 0.5}}
					/>}

					{inPurchaseComplete && (
						<TopBarPurchaseComplete
							key="purchase"
						/>
					)}

					{inRewardMode && (
						<TopBarAchReward
							key="achievement"
							firstStarAnimated={this.firstStarAnimated}
							lastStarAnimated={this.lastStarAnimated}
							onStarsComplete={this.onStarsComplete}
						/>
					)}

					{inLevelUpMode && (
						<TopBarLevelUp
							key="level"
							onHeartsComplete={this.heartsComplete}
						/>
					)}

					{showCountdownModal && (
						<TopBarAdModal
							countdown
							key="countdown"
							onHeartsComplete={this.adHeartsComplete}
						/>
					)}
				</AnimatePresence>
				{inTimedHeartMode && (
					<React.Fragment>
						{/* Timed Hearts */}
						{times(store.showTimedHeartAward, (n) => {
							var d = max([(0.15 - (n * 0.01)),0.03]);
							delayIncrement += d;
							return (
								<Heart
									onAnimationComplete={n + 1 === store.showTimedHeartAward ? this.timedHeartsComplete : null}
									key={`star-${n}`}
									initial={{x: '83vw', y: '90vh', scale: 0}}
									animate={{x: '74vw', y: '-1vw', scale: [0,1,1,0]}}
									transition={{
										default: {delay: 0 + delayIncrement, duration: 1.5, ease: 'easeInOut'}
									}}
									src="/assets/hud/hud_icon_heart.png"
								/>
							);
						})}
					</React.Fragment>
				)}
				{store.activeMatch === null && <React.Fragment>
					<div style={{marginLeft:'2vw'}}>
						{this.props.onClick ? (
							<ButtonMover id="topbar-nav-button" onClick={this.props.onClick}>
								<img draggable="false" alt="to" style={{width: '10vw'}} src="/assets/hud/hud_back.png"/>
							</ButtonMover>
						) : store.topBar.to ? (
							<ButtonMover id="topbar-nav-button" onClick={() => this.backTo()}>
								<img draggable="false" alt="to" style={{width: '10vw'}} src="/assets/hud/hud_back.png"/>
							</ButtonMover>
						) : this.props.back ? (
							<ButtonMover id="topbar-nav-button" onClick={() => this.back()}>
								<img draggable="false" alt="back" style={{width: '10vw'}} src="/assets/hud/hud_back.png"/>
							</ButtonMover>
						) : (
							<ButtonMover onClick={this.openProfile}>
								<img draggable="false" alt="profile" style={{width: '10vw'}} src="/assets/hud/hud_theme_profile.png"/>
							</ButtonMover>
						)}
					</div>
					<IconBar style={{flexBasis: '24vw'}}>
						<LvlBar key={`lvl-bar-${store.user.xpData.currentLevel}`}>
							<ProgressBar rightCurveOnly
								onAnimationComplete={this.barAnimationComplete}
								initial={{
									width: store.user.xpData.previousPercentage+'%'
								}}

								animate={{
									width: store.user.xpData.currentPercentage+'%'
								}}

								transition={{
									delay: store.user.xpData.delay,
									duration: delayBeforeFirstStar + delayIncrement
								}}
							/>
						</LvlBar>
						<motion.img
							animate={inRewardMode ? {
								scale: 1.4,
								transition: {
									delay: delayBeforeFirstStar + 0.8,
									duration: 2
								}
							} : {scale: 1} }
							draggable="false" alt="star icon" style={{width: '13vw'}} src="/assets/hud/hud_icon_star.png"/>
						<Level style={{
							fontSize: `${5.75 - (store.user.xpData.currentLevel.toString().length - 1)}vw`
						}}>{store.user.xpData.currentLevel}</Level>
					</IconBar>
					<div><img draggable="false" alt="Shake It Up!" style={{width: '24.3vw'}} src="/assets/hud/hud_siu_logo_tiny.png"/></div>
					<IconBar onClick={this.openStore} style={{flexGrow: 1}}>
						<HeartBar><ProgressBar rightCurveOnly percent={0}><HeartNumber style={{fontSize: store.user.hearts.toString().length > 2 ? '4vw' : '5vw' }}>{store.user.hearts}</HeartNumber></ProgressBar></HeartBar>
						<motion.img
							animate={inLevelUpMode ? {
								scale: 1.2,
								transition: {
									delay: delayBeforeFirstStar + 0.8,
									duration: 2
								}
							} : {scale: 1} }
							draggable="false" alt="heart icon" style={{width: '13vw'}} src="/assets/hud/hud_icon_heart.png"
						/>
						<img draggable="false" alt="" src="/assets/hud/hud_btn_plus.png" style={{top: '8vw', left: '21vw', width: '5vw'}}/>
					</IconBar>
				</React.Fragment>}
			</Body>
		)
	}
}
